// extracted by mini-css-extract-plugin
export var grid = "brands-module--grid--06afa";
export var inner = "brands-module--inner--24ce4";
export var link = "brands-module--link--62d07";